// extracted by mini-css-extract-plugin
module.exports = {"InfoFormContainer":"volunteerForm_InfoFormContainer__G4hG1","firstNameBox":"volunteerForm_firstNameBox__3DEUT","buttonSubmit":"volunteerForm_buttonSubmit__hKPmf"};